import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const WHATSAPP_URL = "https://wa.me/919845201215?text=Hello%20Amrut%20Group";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-ivory/80">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-3xl md:text-4xl text-ivory font-light tracking-tight mb-6">
              Amrut Group
            </h3>
            <p className="text-sm leading-relaxed text-ivory/50 max-w-xs">
              A legacy of stay and taste on the pristine coast of Karwar, Karnataka.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="overline-text text-gold mb-8">Explore</p>
            <div className="flex flex-col gap-4">
              {[
                { label: "Home", path: "/" },
                { label: "About Us", path: "/about" },
                { label: "Seafood Restaurant", path: "/amrut-seafood" },
                { label: "Amrut Aura", path: "/amrut-aura" },
                { label: "Amrut Inn", path: "/amrut-inn" },
                { label: "Amrut Jewellers", path: "/amrut-jewellers" },
                { label: "Amrut Delight", path: "/amrut-delight" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-sm text-ivory/50 hover:text-ivory transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* WhatsApp CTA */}
          <div>
            <p className="overline-text text-gold mb-8">Get in Touch</p>
            <p className="text-sm text-ivory/50 mb-6 leading-relaxed">
              For reservations and inquiries, reach us directly on WhatsApp.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 px-6 py-3 border border-ivory/20 text-ivory text-xs tracking-[0.15em] uppercase font-medium hover:bg-ivory/10 transition-all duration-300"
            >
              <Phone size={13} strokeWidth={1.5} />
              WhatsApp Us
            </a>
          </div>
        </div>

        <Separator className="my-16 bg-ivory/10" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-ivory/30">
            &copy; {new Date().getFullYear()} Amrut Group. All rights reserved.
          </p>
          <p className="text-xs text-ivory/30">
            Karwar, Karnataka, India
          </p>
        </div>
      </div>
    </footer>
  );
}
